// The lease builder's per-animal accommodation labels (AnimalsSection). Internal staff copy only:
// nothing here reaches the lease (counsel Rule H) — the $0 charge is the lease's only trace.
//
// RRA v2.1 (Decision 2): an OPEN request lists its animal at $0 through a pending per-animal
// exemption, and the lease state is deliberately identical to an approved one. So the builder learns
// "pending" from the review summary's open-request animal names, never from the pet itself.

/** DRAFT — the label on an animal listed at $0 because its accommodation request is still open. */
export const RRA_PENDING_ANIMAL_LABEL = 'Accommodation request open — listed at no charge while we decide';

const norm = (s: string | undefined): string => (s ?? '').trim().toLowerCase();

/** True when this pet is the animal of an OPEN accommodation request (matched by name). */
export function isPendingAccommodationAnimal(petName: string | undefined, pendingAnimalNames: readonly string[]): boolean {
  const n = norm(petName);
  return n.length > 0 && pendingAnimalNames.some((p) => norm(p) === n);
}

/** The badge beside an exempt animal: pending request, approved (on file), or a build-time note. */
export function raExemptionBadge(opts: { memorialized: boolean; pending: boolean }): string {
  if (opts.memorialized && opts.pending) return RRA_PENDING_ANIMAL_LABEL;
  return opts.memorialized ? 'RA — fees waived' : 'RA — fees waived (records at send)';
}
